module.exports = __webpack_public_path__ + "img/kbi-bw-logo.7f5ebf1d.png";